import * as React from 'react';
import { StockIndicator } from '@grandvisionhq/inventory';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';

const ProductStockIndicator = ()=>{
    const { activeVariant: { stock , channelAvailability  } ,  } = useProductData();
    return /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: stock.stockCount,
        allowBackOrder: stock.isAllowBackOrder,
        channelAvailability: channelAvailability
    });
};

export { ProductStockIndicator };
//# sourceMappingURL=ProductStockIndicator.js.map
